import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    landingPage: 'no' //
  },
  getters: {
    landingPage: (state) => state.landingPage //    landingPage
  },
  mutations: {
    setLandingPage (state, value) {
      state.landingPage = value //    landingPage
    }
  },
  actions: {
    updateLandingPage ({ commit }, value) {
      commit('setLandingPage', value) //    mutation    state
    }
  },
  modules: {
  }
})
